import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';

import localUtil from '../../lib/util';
import fields from '../../lib/fields';

import FormFieldsCompact from '../../components/form/fieldsCompact';
import Input from '../../components/form/input';

@withText(props => ({
    title: <Text id='input.title-help'>title</Text>,
}))
@observer
class EditCourse extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sections: fields.get('course'),
        };
    }

    loadAll = async (props = this.props, emptyFirst = true) => {
        const { id, isNew } = props;
        const { courseStore } = this.props.stores;

        courseStore.loadExamOptions();

        if (!isNew && id) {
            await courseStore.load(id, false, {
                addData: ['tags'],
            });
        }

        if (isNew) {
            const { newCourse } = courseStore;
            // Only set defaults if newCourse is empty (not pre-populated from copy)
            if (!newCourse || !newCourse.title) {
                courseStore.updateKeyValue('newCourse', {
                    active: 1,
                    public: 1,
                    registrationIsOpen: true,
                    selfSignup: true,
                    vat: 25,
                });
            }
        }
    }

    createCourse = async () => {
        const { callback = () => {} } = this.props;
        const { courseStore, appState } = this.props.stores;
        const { newCourse } = courseStore;

        const response = await courseStore.insert(newCourse);

        if (response && response.status < 300) {
            courseStore.updateKeyValue('newCourse', {});
            appState.addToast({
                type: 'success',
                message: 'Kurs opprettet!',
            }, 3000);
            callback();
        } else {
            appState.addToast({
                type: 'error',
                message: response?.message || 'Kunne ikke opprette kurs',
            }, 5000);
        }
    }

    chooseItem = (e) => {
        const { id } = e.target.closest('.similar-item').dataset;
        const { courseStore } = this.props.stores;
        const { foundList } = courseStore;
        const item = foundList.find((item) => item.id === parseInt(id, 10));
        courseStore.updateKeyValue('newCourse', {
            ...item,
        });
        courseStore.resetSearch();
    }

    toggleSimilar = () => {
        const { showSimilar } = this.state;
        this.setState({
            showSimilar: !showSimilar,
        });
    }

    componentDidMount() {
        this.loadAll();
    }

    render() {
        const { isNew, drawerLevel, lookupArray } = this.props;
        const { sections, showSimilar } = this.state;
        const { userStore, courseStore } = this.props.stores;
        const { user, isAdmin } = userStore;
        const { newCourse, foundList } = courseStore;
        const darkmode = util.getNestedValue(user, 'settings.darkmode');

        return (<>
            <div class='w-100 d-flex justify-content-center position-relative'>
                <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>
                    <div class='font-weight-lighter px-3 box-header mt-0'>
                        {isNew ? <Text id='course.new'>Nytt kurs</Text> : <Text id='course.edit'>Rediger kurs</Text>}
                    </div>

                    <div class='w-100 d-flex flex-column justify-content-start'>
                        <div class='bg-light d-flex flex-column justify-content-start h-100 pt-3'>
                            <FormFieldsCompact
                                stores={this.props.stores}
                                sections={sections}
                                holdingStore={courseStore}
                                objectName={isNew ? 'newCourse' : 'course'}
                                isNew={isNew}
                                defaultShowOnlyRecommended={false}
                                drawerLevel={drawerLevel}
                                isAdmin={false}
                                hideAdmin={!isAdmin}
                                lookupArray={lookupArray}
                                rightHeader={isNew && foundList?.length > 0 ? (
                                    <span class='text-success font-weight-bold'>
                                        <i class='fa-solid fa-circle-info' /> Similar courses ({foundList.length})
                                    </span>
                                ) : null}
                                rightHeaderClick={this.toggleSimilar}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {isNew && (
                <div class='w-100 d-flex flex-column justify-content-start mt-3 px-4 py-3 bg-light fixed-bottom' style={`bottom: 0; left: 0;`}>
                    <button type='button' class='btn btn-primary rounded-pill' onClick={this.createCourse}>
                        {isNew ? <Text id='course.create'>Opprett kurs</Text> : <Text id='course.save'>Lagre kurs</Text>}
                    </button>
                </div>
            )}
        </>);
    }
}

export default EditCourse;
